angular.module('app').factory('mediaService', [
    'Restangular',
    'settings',
    function (Restangular, settings) {
        var restAngular = Restangular.withConfig(function (Configurer)
        {
            Configurer.setBaseUrl(settings.apiURL);
        });

        restAngular = restAngular.all("/media/");

        return {
            addImage: function (requestData) {
                return restAngular.one("create").post("", requestData)
            },
            getImages: function (requestObject) {
                return restAngular.one("get").customGET(param(requestObject))
            },
            getImageList: function (requestObject) {
                return restAngular.one("getList").customGET(param(requestObject))
            },
            getLogos: function () {
                return restAngular.one("get").customGET(param({"logos": true}))
            },
            changeImageStatus: function (requestData) {
                return restAngular.one("changeStatus").post("", {media: requestData})
            },
            getGameImages: function (requestData) {
                return restAngular.one("getGameImages").customGET(param(requestData))
            },
            changeGroupStatus: function (requestData) {
                return restAngular.one("changeGroupStatus").post("", {media: requestData})
            }
        }
    }
]);
